export default __webpack_public_path__ + "static/media/wordpress.6d3483fa.svg";